var map = {
	"./goldcoin/boost-list-icon-3.png": 27043,
	"./memetown/boost-list-icon-3.png": 99981,
	"./reflection/boost-list-icon-3.png": 34636,
	"./tapcoin/boost-list-icon-3.png": 43444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66216;